export const Method = {
  GET: `GET`,
  POST: `POST`,
};

export const SuccessHTTPStatusRange = {
  MIN: 200,
  MAX: 299,
};

const Url = {
  REGISTRATION: `/user-action/registration-by-phone?ajax=1`,
  REGISTRATION_EMAIL: `/user-action/registration-by-email`,
  LOG_IN: `/user-action/send-sms-login?ajax=1`,
  LOG_IN_EMAIL: `/user-action/login`,
  CODE_REGISTRATION: `/user-action/phone-login?ajax=1&registration=1`,
  CODE_LOG_IN: `/user-action/phone-login?ajax=1`,
  ORDER_CHECK_EMAIL: `/ajax-user-action/is-email`,
  ORDER_CHECK_PHONE: `/ajax-user-action/is-phone`,
  ORDER_CHECK_PIN_EMAIL: `/ajax-user-action/is-code`,
  ORDER_CHECK_PIN_PHONE: `/ajax-user-action/phone-is-code`,
  SEND_LOCATION: `/ajax-user-action/location-city`,
  SEND_DELIVERY_COURIER_LOCATION: `/ajax-user-action/region`,
  GET_USER_IP: `/ajax-user-action/ip`,
  FAST_ORDER: `/actions/product-action/order`,
  PRICE_REQUEST: `/actions/product-action/price-request`,
  ARRIVAL_REQUEST: `/actions/product-action/arrival-request`,
  CHECK_PROMO_CODE: `/order/is-promo-code?code=`,
  GET_PRODUCT_INFO: `/product?id=`,
};

const TestUrl = {
  REGISTRATION: `/data/reg.json`,
  REGISTRATION_EMAIL: `/data/reg-email.json`,
  LOG_IN: `/data/login.json`,
  LOG_IN_EMAIL: `/data/login-email.json`,
  CODE_REGISTRATION: `/data/reg-code.json`,
  CODE_LOG_IN: `/data/login-code.json`,
  ORDER_CHECK_EMAIL: `/data/email-check.json`,
  ORDER_CHECK_PHONE: `/data/phone-check.json`,
  ORDER_CHECK_PIN_EMAIL: `/data/code-email-check.json`,
  ORDER_CHECK_PIN_PHONE: `/data/code-phone-check.json`,
  SEND_LOCATION: `/data/send-location.json`,
  SEND_DELIVERY_COURIER_LOCATION: `/data/send-location-courier.json`,
  GET_USER_IP: `/data/user-ip.json`,
  FAST_ORDER: `/data/fast-order.json`,
  PRICE_REQUEST: `/data/price-request.json`,
  ARRIVAL_REQUEST: `/data/arrival-request.json`,
  CHECK_PROMO_CODE: `/data/promo.json?code=`,
  GET_PRODUCT_INFO: `/data/product.json?id=`,
};

export class Api {
  constructor() {}

  checkUserEmail(email) {
    return this._load({
      url: `${Url.ORDER_CHECK_EMAIL}?email=${email}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  checkUserPhone(phone) {
    return this._load({
      url: `${Url.ORDER_CHECK_PHONE}?phone=${phone}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  checkUserPinEmail(email, pin) {
    return this._load({
      url: `${Url.ORDER_CHECK_PIN_EMAIL}?email=${email}&code=${pin}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  checkUserPinPhone(phone, pin) {
    return this._load({
      url: `${Url.ORDER_CHECK_PIN_PHONE}?phone=${phone}&code=${pin}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  sendLoginPhone(data) {
    return this._load({
      url: Url.LOG_IN,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendLoginEmail(data) {
    return this._load({
      url: Url.LOG_IN_EMAIL,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendLoginCode(data) {
    return this._load({
      url: Url.CODE_LOG_IN,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendRegistrationPhone(data) {
    return this._load({
      url: Url.REGISTRATION,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendRegistrationEmail(data) {
    return this._load({
      url: Url.REGISTRATION_EMAIL,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendRegistrationCode(data) {
    return this._load({
      url: Url.CODE_REGISTRATION,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendLocation(city, region) {
    return this._load({
      url: `${Url.SEND_LOCATION}/?locationCity=${city}&region=${region}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  sendCourierDeliveryRegion(region) {
    return this._load({
      url: `${Url.SEND_DELIVERY_COURIER_LOCATION}?region=${region}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  getUserIp() {
    return this._load({
      url: Url.GET_USER_IP,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  sendFastOrder(data) {
    return this._load({
      url: Url.FAST_ORDER,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendPriceRequest(data) {
    return this._load({
      url: Url.PRICE_REQUEST,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  sendArrivalRequest(data) {
    return this._load({
      url: Url.ARRIVAL_REQUEST,
      method: Method.POST,
      query: data,
    }).then(Api.toJSON);
  }

  checkPromoCode(code) {
    return this._load({
      url: `${Url.CHECK_PROMO_CODE}${code}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  /**
   * Getting product info by product id
   *
   * @param {string} id
   * @return {json}
   * @memberof Api
   */
  getProductInfo(id) {
    return this._load({
      url: `${Url.GET_PRODUCT_INFO}${id}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  customQuery(url, {method = Method.GET, query, headers}) {
    const options = {
      url,
      method,
    };

    if (query) {
      options.query = query;
    }

    if (headers) {
      options.headers = headers;
    }

    return this._load(options).then(Api.toJSON);
  }

  _load({url, query, method, headers}) {
    const options = {
      method,
      mode: `cors`,
    };

    if (headers) {
      options.headers = headers;
    }

    if (query) {
      options.body = query && method === Method.POST ? query : null;
    }
    return fetch(url, options).then(Api.checkStatus).catch(Api.catchError);
  }

  static checkStatus(response) {
    if (response.status < SuccessHTTPStatusRange.MIN || response.status > SuccessHTTPStatusRange.MAX) {
      console.error(`${response.status}: ${response.statusText}`);
      return `error`;
      // throw new Error(`${response.status}: ${response.statusText}`);
    }
    return response;
  }

  static redirect(response) {
    if (response.redirected) {
      document.location = response.url;
    } else {
      console.log(`Код введен не верно`);
    }
  }

  static toJSON(response) {
    if (response === `error`) {
      return response;
    }
    return response.json();
  }

  static catchError(err) {
    throw err;
  }
}
